import React, { Fragment } from "react";
import { connect } from "react-redux";
import Accordion from "nekrasovka-ui/Accordion";
import Button from "nekrasovka-ui/Button";
import Mention from "containers/Mention";
import Section from "components/Section";
import persons from "modules/persons";
import editing from "modules/editing";
import styled from "styled-components";
import Editing from "containers/Editing";

const { fetchPersons, fetchFilterPersons, clearPersons } = persons.actions;
const { editingToggle } = editing.actions;

const PersonsPageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding-top: 40px;
  position: relative;

  @media (max-width: 820px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 568px) {
    padding-left: 0;
    padding-right: 0;
    padding-top: 20px;
  }
`;

const Alphabet = styled.div`
  line-height: 48px;
  font-size: 48px;
  color: #444444;
  margin: 20px;

  &:first-child {
    margin-top: 0;
  }
`;

class PersonsPage extends React.Component {
  constructor() {
    super();
    this.state = {
      index: null,
      edit: false,
      editName: false,
      indexEdit: null,
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      index: null,
      edit: false,
      indexEdit: null,
      editName: false,
    });
  }

  handleClick = (index, open) => {
    if (open) return this.setState({ index: null, edit: false });

    const state = { ...this.state };
    if (this.state.index !== index) {
      state.index = index;
      state.edit = false;
      state.indexEdit = null;
      state.indexEdit = false;
      this.setState(state);
    }
  };

  onEdit = (indexEdit, editName) => {
    if (editName) return this.setState({ indexEdit: null, editName: false });

    const state = { ...this.state };
    if (this.state.indexEdit !== indexEdit) {
      state.indexEdit = indexEdit;
      state.editName = false;
      state.index = null;
      state.edit = false;
      this.setState(state);
    }
  };

  componentWillUnmount() {
    this.props.clearPersons();
  }

  render() {
    const { persons, field, editing } = this.props;
    return (
      <Section>
        <PersonsPageContainer>
          {persons.map((person, index) => {
            const open = this.state.index === index;
            const editName = this.state.indexEdit === index;
            const isNameSelected =
              person.id === field.id ||
              person["mentions"].some((mention) => mention.id === field.id);
            const alphabetLetter = person.name.substring(0, 1).toUpperCase();
            {
              return editing && isNameSelected ? (
                <Editing />
              ) : (
                <Fragment key={index}>
                  {(!persons[index - 1] ||
                    (persons[index - 1] &&
                      persons[index - 1].name.substring(0, 1).toUpperCase() !==
                        alphabetLetter)) && (
                    <Alphabet>{alphabetLetter}</Alphabet>
                  )}
                  <Accordion
                    key={index}
                    editName={editName}
                    title={person.name}
                    person={`person/${person.id}`}
                    description={person.description}
                    open={open}
                    onHandleClick={() => this.handleClick(index, open)}
                    isContentDisabled={!!person.mentions.length}
                    onEditClick={() => {
                      !!person.mentions.length
                        ? this.setState({ edit: !this.state.edit })
                        : this.onEdit(index, editName);
                    }}
                    onTitleClick={() => {
                      this.state.edit || editName
                        ? this.props.editingToggle(person, "person")
                        : "";
                    }}
                    onDescriptionClick={() =>
                      this.state.edit || editName
                        ? this.props.editingToggle(person, "person")
                        : ""
                    }
                  >
                    {person.mentions.map((mention, index) => (
                      <Mention
                        key={index}
                        edit={this.state.edit}
                        mention={mention}
                      />
                    ))}
                  </Accordion>
                </Fragment>
              );
            }
          })}
          {persons.length > 0 && !this.props.isPersonsFinished && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <Button
                active
                color="#000"
                icon="loading"
                widthIcon={15}
                heightIcon={15}
                onClick={() => this.props.fetchPersons()}
              >
                Загрузить еще
              </Button>
            </div>
          )}
        </PersonsPageContainer>
      </Section>
    );
  }
}

const mapStateToProps = ({
  editing: { editing, field },
  persons: { persons, isPersonsFinished },
}) => ({
  editing,
  field,
  persons,
  isPersonsFinished,
});

export default connect(mapStateToProps, {
  fetchPersons,
  editingToggle,
  fetchFilterPersons,
  clearPersons,
})(PersonsPage);



// WEBPACK FOOTER //
// ./src/containers/PersonsPage/index.js